import typoscript from "refractor/typoscript";
export default typoscript;